/**
 * The click a touch long press would otherwise send after its menu opens, swallowed once (useContextMenu, menu.tsx).
 * Android ends a long press in contextmenu and never sends that click, so every new press clears the guard first:
 * a flag left set would eat the next real tap (the "tap after a long press is swallowed" bug).
 */
export interface ClickGuard {
  /** A new pointer press begins. */
  press(): void;
  /** The long press opened the menu: its click, if one comes, is not a tap. */
  longPressFired(): void;
  /** At click time: true once for the long press's own click, then false. */
  swallow(): boolean;
}

export function clickGuard(): ClickGuard {
  let armed = false;
  return {
    press: () => { armed = false; },
    longPressFired: () => { armed = true; },
    swallow: () => { const was = armed; armed = false; return was; },
  };
}
